export default "__VITE_ASSET__BOmDi1Vz__"